<template>
<b-container>
    <h1>Aléas</h1>

    <b-button variant="primary" @click="openEditModal(null)" class="mt-4 mb-4">Ajouter aléa</b-button>

    <div v-show="gaps.length > 0">
      <b-table ref="gapsTable" small :items="gaps" :fields="fields" :per-page="perPage" :current-page="currentPage">
        <template slot="type" slot-scope="row">
          <span v-html="getGapType(row.item.type)"></span>
        </template>

        <template slot="edit" slot-scope="row">
          <a href="#!" @click.prevent="openEditModal(row.item)" class="mr-2">
            <svg id="editIcon" viewBox="0 0 29.31 29.26" style="enable-background:new 0 0 29.31 29.26;" xml:space="preserve"><path class="st3" d="M28.36,2.12l-1.17-1.17c-1.26-1.27-3.32-1.27-4.59,0L21.26,2.3c0,0,0,0,0,0s0,0,0,0L9.54,14.01 c-0.01,0.01-0.02,0.03-0.03,0.04c-0.05,0.05-0.08,0.11-0.11,0.17c-0.03,0.06-0.07,0.11-0.09,0.17c-0.01,0.02-0.02,0.03-0.02,0.04 L7.5,20.57c-0.1,0.35,0,0.73,0.25,0.99c0.19,0.19,0.45,0.29,0.71,0.29c0.09,0,0.19-0.01,0.28-0.04l6.13-1.79 c0.02-0.01,0.03-0.02,0.05-0.03c0.06-0.02,0.12-0.06,0.18-0.09c0.06-0.03,0.11-0.06,0.16-0.11c0.01-0.01,0.03-0.02,0.04-0.03 L27.02,8.06c0,0,0,0,0,0s0,0,0,0l1.34-1.34C29.63,5.45,29.63,3.39,28.36,2.12z M21.96,4.42l2.93,2.93l-10.3,10.3l-2.93-2.93 L21.96,4.42z M10.74,16.62l1.96,1.96l-2.76,0.8L10.74,16.62z M26.95,5.3l-0.64,0.64L23.38,3l0.64-0.64c0.48-0.48,1.27-0.48,1.76,0 l1.17,1.17C27.43,4.02,27.43,4.81,26.95,5.3z"/><path class="st3" d="M25.48,16.27c-0.55,0-1,0.45-1,1v5.51c0,2.48-2.01,4.49-4.49,4.49H6.49C4.01,27.26,2,25.25,2,22.77V9.27 c0-2.47,2.01-4.49,4.49-4.49H12c0.55,0,1-0.45,1-1s-0.45-1-1-1H6.49C2.91,2.78,0,5.69,0,9.27v13.51c0,3.58,2.91,6.49,6.49,6.49H20 c3.58,0,6.49-2.91,6.49-6.49v-5.51C26.48,16.72,26.04,16.27,25.48,16.27z"/></svg>
          </a>
          <a href="#!" @click.prevent="openDeleteModal(row.item)">
            <icon name="trash-alt" scale="1"/>
          </a>
        </template>
      </b-table>

      <b-pagination
        id="pagination"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage">
        <template slot="first-text" slot-scope="item">
          <span class="first-link" :class="item.disabled ? 'disabled' : ''">«</span>
        </template>
        <template slot="prev-text" slot-scope="item">
          <span class="prev-link" :class="item.disabled ? 'disabled' : ''">‹</span>
        </template>
        <template slot="page" slot-scope="item">
          <span class="page" :class="item.active ? 'active' : ''">{{ item.page }}</span>
        </template>
        <template slot="next-text" slot-scope="item">
          <span class="next-link" :class="item.disabled ? 'disabled' : ''">›</span>
        </template>
        <template slot="last-text" slot-scope="item">
          <span class="last-link" :class="item.disabled ? 'disabled' : ''">»</span>
        </template>
        <template slot="ellipsis-text">
          <span class="ellipsis">...</span>
        </template>
      </b-pagination>
    </div>

    <b-modal id="gapModal" title="Aléa" hide-footer>
      <b-form @submit.prevent="saveGap">
        <b-form-group label="Code" label-cols="2">
          <b-input v-model="currentGap.code" placeholder="Code (A01, B12...)" required/>
        </b-form-group>

        <b-form-group label="Type" label-cols="2">
          <select class="custom-select" required v-model="currentGap.type">
            <option :value="null" disabled selected>-- Merci de choisir un type --</option>
            <option v-for="(type, index) in gapTypes" :key="index" :value="index + 1" :selected="currentGap.type == type.value">{{ type.text }}</option>
          </select>
        </b-form-group>

        <b-form-group label="Description" label-cols="2">
          <b-textarea v-model="currentGap.description"></b-textarea>
        </b-form-group>

        <b-row>
          <b-col align-self="center" class="text-center">
            <b-button type="submit" variant="primary" id="save"><svg id="savePicto" viewBox="0 0 24.42 20" style="enable-background:new 0 0 24.42 20;" xml:space="preserve"><path class="st3" d="M24.15,6.71c-0.31-0.41-0.85-0.67-1.41-0.67h-1.31V3.82c0-0.9-0.71-1.63-1.58-1.63h-8.99l-1.3-1.85 C9.42,0.13,9.17,0,8.91,0H1.72C0.81,0,0.07,0.74,0.07,1.65v16.33c-0.13,0.44-0.08,0.91,0.17,1.3C0.53,19.73,1.04,20,1.61,20h16.95 c1.14,0,1.44-0.91,1.59-1.35l4.2-10.73C24.48,7.5,24.41,7.06,24.15,6.71z M8.48,1.62l1.3,1.85c0.15,0.22,0.4,0.34,0.66,0.34l9.36,0 v2.22H5.8c-1.13,0-1.47,1.01-1.59,1.35L1.7,13.78L1.72,1.62H8.48z M18.62,18.09c-0.05,0.14-0.08,0.23-0.11,0.28l-16.88,0L5.73,7.94 C5.78,7.79,5.82,7.7,5.85,7.66h16.87L18.62,18.09z"/><path class="st3" d="M11.64,17.19c0.07,0.08,0.16,0.13,0.26,0.18c0.1,0.04,0.2,0.06,0.31,0.06c0.11,0,0.21-0.02,0.31-0.06 c0.1-0.04,0.19-0.1,0.26-0.18l2.29-2.29c0.32-0.32,0.32-0.83,0-1.15c-0.32-0.32-0.83-0.32-1.15,0l-0.91,0.91V9.42 c0-0.45-0.36-0.81-0.81-0.81c-0.45,0-0.81,0.36-0.81,0.81v5.23l-0.94-0.94c-0.32-0.32-0.83-0.32-1.15,0 c-0.32,0.32-0.32,0.83,0,1.15L11.64,17.19z"/></svg>Sauvegarder</b-button>
          </b-col>
          <b-col align-self="center" class="text-center">
            <b-button variant="danger" @click="closeModals">Annuler</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal id="deleteGapModal" title="Suppression d'un aléa" hide-footer>
      <b-row class="mt-4 mb-4">
        <p>Êtes-vous sûr(e) de vouloir supprimer l'aléa <strong>{{ currentGap.code }}</strong> ?</p>
        <p><strong>Attention :</strong> Cette opération est irréversible.</p>
      </b-row>
      <b-row>
        <b-col align-self="center" class="text-center">
          <b-button variant="primary" id="delete" @click.prevent="deleteGap">Confirmer</b-button>
        </b-col>
        <b-col align-self="center" class="text-center">
          <b-button variant="danger" @click="closeModals">Annuler</b-button>
        </b-col>
      </b-row>
    </b-modal>

</b-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      gaps: [],
      perPage: 15,
      currentPage: 1,
      currentGap: {
        code: null,
        type: null,
        description: null,
      },
      gapTypes: [
        {
          text: 'Réactivité',
          value: 1,
        },
        {
          text: 'Incomplétude',
          value: 2,
        },
        {
          text: 'Irrecevabilité',
          value: 3,
        },
      ],
      fields: [
        {
          key: 'code',
          label: 'Code',
          sortable: true,
        },
        {
          key: 'type',
          label: 'Type',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
        },
        {
          key: 'edit',
          label: 'Actions',
        }
      ],
      toast: {
        show: true,
        message: null,
        variant: null,
        duration: 3000,
      }
    }
  },
  mounted() {
    // Access check
    if (!this.isAdmin() && !this.isAgent()) {
        this.$router.push({ name: 'dashboard' });
    }

    // Fetching gaps data
    axios.get('gaps')
        .then((response) => {
          this.gaps = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
  },
  computed: {
    rows() {
      return this.gaps.length;
    }
  },
  methods: {
    ...mapGetters([
      'isAdmin',
      'isAgent',
    ]),
    openEditModal(gap) {
      if (gap == null) {
        this.resetCurrentGap();
      } else {
        this.currentGap = {
          id: gap.id,
          code: gap.code,
          type: gap.type,
          description: gap.description,
        };
      }
      this.$bvModal.show('gapModal');
    },
    openDeleteModal(gap) {
      this.currentGap = {
        id: gap.id,
        code: gap.code,
      };
      this.$bvModal.show('deleteGapModal');
    },
    closeModals() {
      this.resetCurrentGap();
      this.$bvModal.hide('gapModal');
      this.$bvModal.hide('deleteGapModal');
    },
    getGapType(type) {
      switch (type) {
        case 1:
          return 'Réactivité';
          break;

        case 2:
          return 'Incomplétude';
          break;

        case 3:
          return 'Irrecevabilité';
          break;

        default:
          return 'Inconnu';
          break;
      }
    },
    saveGap() {
      if (this.currentGap.id) {
        // Update
        axios.patch(`gaps/${this.currentGap.id}`, {
          code: this.currentGap.code,
          description: this.currentGap.description,
          type: this.currentGap.type,
        })
          .then((response) => {
            // Updating data
            let i = 0;
            this.gaps.forEach((gap) => {
              if (gap.id === response.data.id) {
                this.gaps[i] = response.data;
                return;
              } else {
                i++;
              }
            });

            // Force table refresh
            this.$refs.gapsTable.refresh();
            this.toast.message = 'Aléa modifié avec succès !';
            this.toast.variant = 'success';
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
              this.toast.message = 'Impossible de modifier cet aléa. Vous ne disposez pas des droits suffisants.';
              this.toast.variant = 'danger';
            } else {
              console.error(error);
              this.toast.message = 'Une erreur est survenue lors de cette opération. Veuillez nous excuser pour la gêne occasionnée.';
              this.toast.variant = 'danger';
            }
          })
          .finally(() => {
            this.$store.commit('setGlobalToaster', this.toast);
            this.closeModals();
            this.resetCurrentGap();
          });
      } else {
        // Create
        axios.post('gaps', {
          code: this.currentGap.code,
          description: this.currentGap.description,
          type: this.currentGap.type,
        })
          .then((response) => {
            this.gaps.push(response.data);
            this.toast.message = 'Aléa modifié avec succès !';
            this.toast.variant = 'success';
          })
          .catch((error) => {
            if (error.response && error.response.status === 403) {
              this.toast.message = 'Impossible de créer un aléa. Vous ne disposez pas des droits suffisants.';
              this.toast.variant = 'danger';
            } else {
              console.error(error);
              this.toast.message = 'Une erreur est survenue lors de cette opération. Veuillez nous excuser pour la gêne occasionnée.';
              this.toast.variant = 'danger';
            }
          })
          .finally(() => {
            this.$store.commit('setGlobalToaster', this.toast);
            this.closeModals();
            this.resetCurrentGap();
          });
      }
    },
    deleteGap() {
      if (!this.currentGap.id) {
        this.closeModals();
      } else {
        axios.delete(`gaps/${this.currentGap.id}`)
            .then((response) => {
              this.toast.message = 'Opération réalisée avec succès.';
              this.toast.variant = 'success';
              let i = 0;
              this.gaps.forEach((gap) => {
                if (gap.id === this.currentGap.id) {
                  this.gaps.splice(i, 1);
                  return;
                } else {
                    i++;
                }
              });
              this.$refs.gapsTable.refresh();
            })
            .catch((error) => {
              if (error.response && error.response.status === 403) {
                this.toast.message = 'Impossible de supprimer cet aléa : il est déjà assigné à une affaire ou vous ne disposez pas des droits suffisants.';
                this.toast.variant = 'danger';
              } else {
                console.error(error);
              }
            })
            .finally(() => {
              this.$store.commit('setGlobalToaster', this.toast);
              this.closeModals();
              this.resetCurrentGap();
            });
      }
    },
    resetCurrentGap() {
      this.currentGap = {
        code: null,
        description: null,
        type: null,
      };
    }
  }
}
</script>
<style lang="scss" scoped>
#save {
  #savePicto {
    fill: white;
    width: 25px;
    margin-right: 10px
  }

  &:hover,
  &:focus,
  &:active {
    background-color: white;
    color: #005EB8;

    #savePicto {
      fill: #005EB8 !important;
    }
  }
}

#editIcon {
  fill: #005EB8;
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/gaps/Gaps.vue